// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"412":"52f8a1fc","2332":"ccbcf5b4","3583":"f42dc822","3775":"52f8a1fc","3783":"98c1d4ce","3964":"52f8a1fc","4075":"52f8a1fc","4542":"52f8a1fc","4821":"98c1d4ce","7402":"f42dc822"}[chunkId] + ".chunk.css";
};